module.exports = __webpack_public_path__ + "static/img/training.c60f030.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/tiles/training.png
// module id = 8qNZ
// module chunks = 1